$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel").click(function(){  
$("#BlackWindow, #lightbox-panel").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel").click(function(){  
$("#BlackWindow, #lightbox-panel").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow").click(function(){  
$("#BlackWindow, #lightbox-panel,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel2").click(function(){  
$("#BlackWindow2, #lightbox-panel2").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel2").click(function(){  
$("#BlackWindow2, #lightbox-panel2").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow2").click(function(){  
$("#BlackWindow2, #lightbox-panel2,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
}) 

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel3").click(function(){  
$("#BlackWindow3, #lightbox-panel3").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel3").click(function(){  
$("#BlackWindow3, #lightbox-panel3").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow3").click(function(){  
$("#BlackWindow3, #lightbox-panel3,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel4").click(function(){  
$("#BlackWindow4, #lightbox-panel4").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel4").click(function(){  
$("#BlackWindow4, #lightbox-panel4").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow4").click(function(){  
$("#BlackWindow4, #lightbox-panel4,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel5").click(function(){  
$("#BlackWindow5, #lightbox-panel5").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel5").click(function(){  
$("#BlackWindow5, #lightbox-panel5").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow5").click(function(){  
$("#BlackWindow5, #lightbox-panel5,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel6").click(function(){  
$("#BlackWindow6, #lightbox-panel6").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel6").click(function(){  
$("#BlackWindow6, #lightbox-panel6").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow6").click(function(){  
$("#BlackWindow6, #lightbox-panel6,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel7").click(function(){  
$("#BlackWindow7, #lightbox-panel7").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel7").click(function(){  
$("#BlackWindow7, #lightbox-panel7").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow7").click(function(){  
$("#BlackWindow7, #lightbox-panel7,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel8").click(function(){  
$("#BlackWindow8, #lightbox-panel8").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel8").click(function(){  
$("#BlackWindow8, #lightbox-panel8").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow8").click(function(){  
$("#BlackWindow8, #lightbox-panel8,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel9").click(function(){  
$("#BlackWindow9, #lightbox-panel9").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel9").click(function(){  
$("#BlackWindow9, #lightbox-panel9").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow9").click(function(){  
$("#BlackWindow9, #lightbox-panel9,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel10").click(function(){  
$("#BlackWindow10, #lightbox-panel10").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel10").click(function(){  
$("#BlackWindow10, #lightbox-panel10").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow10").click(function(){  
$("#BlackWindow10, #lightbox-panel10,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel11").click(function(){  
$("#BlackWindow11, #lightbox-panel11").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel11").click(function(){  
$("#BlackWindow11, #lightbox-panel11").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow11").click(function(){  
$("#BlackWindow11, #lightbox-panel11,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel12").click(function(){  
$("#BlackWindow12, #lightbox-panel12").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel12").click(function(){  
$("#BlackWindow12, #lightbox-panel12").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow12").click(function(){  
$("#BlackWindow12, #lightbox-panel12,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel13").click(function(){  
$("#BlackWindow13, #lightbox-panel13").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel13").click(function(){  
$("#BlackWindow13, #lightbox-panel13").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow13").click(function(){  
$("#BlackWindow13, #lightbox-panel13,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel14").click(function(){  
$("#BlackWindow14, #lightbox-panel14").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel14").click(function(){  
$("#BlackWindow14, #lightbox-panel14").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow14").click(function(){  
$("#BlackWindow14, #lightbox-panel14,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel15").click(function(){  
$("#BlackWindow15, #lightbox-panel15").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel15").click(function(){  
$("#BlackWindow15, #lightbox-panel15").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow15").click(function(){  
$("#BlackWindow15, #lightbox-panel15,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel16").click(function(){  
$("#BlackWindow16, #lightbox-panel16").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel16").click(function(){  
$("#BlackWindow16, #lightbox-panel16").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow16").click(function(){  
$("#BlackWindow16, #lightbox-panel16,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel17").click(function(){  
$("#BlackWindow17, #lightbox-panel17").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel17").click(function(){  
$("#BlackWindow17, #lightbox-panel17").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow17").click(function(){  
$("#BlackWindow17, #lightbox-panel17,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel18").click(function(){  
$("#BlackWindow18, #lightbox-panel18").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel18").click(function(){  
$("#BlackWindow18, #lightbox-panel18").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow18").click(function(){  
$("#BlackWindow18, #lightbox-panel18,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel19").click(function(){  
$("#BlackWindow19, #lightbox-panel19").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel19").click(function(){  
$("#BlackWindow19, #lightbox-panel19").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow19").click(function(){  
$("#BlackWindow19, #lightbox-panel19,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel20").click(function(){  
$("#BlackWindow20, #lightbox-panel20").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel20").click(function(){  
$("#BlackWindow20, #lightbox-panel20").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow20").click(function(){  
$("#BlackWindow20, #lightbox-panel20,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel21").click(function(){  
$("#BlackWindow21, #lightbox-panel21").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel21").click(function(){  
$("#BlackWindow21, #lightbox-panel21").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow21").click(function(){  
$("#BlackWindow21, #lightbox-panel21,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel22").click(function(){  
$("#BlackWindow22, #lightbox-panel22").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel22").click(function(){  
$("#BlackWindow22, #lightbox-panel22").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow22").click(function(){  
$("#BlackWindow22, #lightbox-panel22,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel23").click(function(){  
$("#BlackWindow23, #lightbox-panel23").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel23").click(function(){  
$("#BlackWindow23, #lightbox-panel23").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow23").click(function(){  
$("#BlackWindow23, #lightbox-panel23,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel24").click(function(){  
$("#BlackWindow24, #lightbox-panel24").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel24").click(function(){  
$("#BlackWindow24, #lightbox-panel24").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow24").click(function(){  
$("#BlackWindow24, #lightbox-panel24,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel25").click(function(){  
$("#BlackWindow25, #lightbox-panel25").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel25").click(function(){  
$("#BlackWindow25, #lightbox-panel25").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow25").click(function(){  
$("#BlackWindow25, #lightbox-panel25,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel26").click(function(){  
$("#BlackWindow26, #lightbox-panel26").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel26").click(function(){  
$("#BlackWindow26, #lightbox-panel26").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow26").click(function(){  
$("#BlackWindow26, #lightbox-panel26,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel27").click(function(){  
$("#BlackWindow27, #lightbox-panel27").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel27").click(function(){  
$("#BlackWindow27, #lightbox-panel27").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow27").click(function(){  
$("#BlackWindow27, #lightbox-panel27,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel28").click(function(){  
$("#BlackWindow28, #lightbox-panel28").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel28").click(function(){  
$("#BlackWindow28, #lightbox-panel28").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow28").click(function(){  
$("#BlackWindow28, #lightbox-panel28,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  


//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel29").click(function(){  
$("#BlackWindow29, #lightbox-panel29").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel29").click(function(){  
$("#BlackWindow29, #lightbox-panel29").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow29").click(function(){  
$("#BlackWindow29, #lightbox-panel29,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel30").click(function(){  
$("#BlackWindow30, #lightbox-panel30").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel30").click(function(){  
$("#BlackWindow30, #lightbox-panel30").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow30").click(function(){  
$("#BlackWindow30, #lightbox-panel30,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel31").click(function(){  
$("#BlackWindow31, #lightbox-panel31").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel31").click(function(){  
$("#BlackWindow31, #lightbox-panel31").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow31").click(function(){  
$("#BlackWindow31, #lightbox-panel31,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel32").click(function(){  
$("#BlackWindow32, #lightbox-panel32").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel32").click(function(){  
$("#BlackWindow32, #lightbox-panel32").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow32").click(function(){  
$("#BlackWindow32, #lightbox-panel32,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel33").click(function(){  
$("#BlackWindow33, #lightbox-panel33").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel33").click(function(){  
$("#BlackWindow33, #lightbox-panel33").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow33").click(function(){  
$("#BlackWindow33, #lightbox-panel33,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel34").click(function(){  
$("#BlackWindow34, #lightbox-panel34").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel34").click(function(){  
$("#BlackWindow34, #lightbox-panel34").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow34").click(function(){  
$("#BlackWindow34, #lightbox-panel34,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel35").click(function(){  
$("#BlackWindow35, #lightbox-panel35").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel35").click(function(){  
$("#BlackWindow35, #lightbox-panel35").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow35").click(function(){  
$("#BlackWindow35, #lightbox-panel35,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel35").click(function(){  
$("#BlackWindow35, #lightbox-panel35").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel35").click(function(){  
$("#BlackWindow35, #lightbox-panel35").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow35").click(function(){  
$("#BlackWindow35, #lightbox-panel35,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel36").click(function(){  
$("#BlackWindow36, #lightbox-panel36").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel36").click(function(){  
$("#BlackWindow36, #lightbox-panel36").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow36").click(function(){  
$("#BlackWindow36, #lightbox-panel36,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel37").click(function(){  
$("#BlackWindow37, #lightbox-panel37").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel37").click(function(){  
$("#BlackWindow37, #lightbox-panel37").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow37").click(function(){  
$("#BlackWindow37, #lightbox-panel37,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel38").click(function(){  
$("#BlackWindow38, #lightbox-panel38").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel38").click(function(){  
$("#BlackWindow38, #lightbox-panel38").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow38").click(function(){  
$("#BlackWindow38, #lightbox-panel38,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel39").click(function(){  
$("#BlackWindow39, #lightbox-panel39").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel39").click(function(){  
$("#BlackWindow39, #lightbox-panel39").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow39").click(function(){  
$("#BlackWindow39, #lightbox-panel39,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel40").click(function(){  
$("#BlackWindow40, #lightbox-panel40").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel40").click(function(){  
$("#BlackWindow40, #lightbox-panel40").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow40").click(function(){  
$("#BlackWindow40, #lightbox-panel40,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel41").click(function(){  
$("#BlackWindow41, #lightbox-panel41").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel41").click(function(){  
$("#BlackWindow41, #lightbox-panel41").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow41").click(function(){  
$("#BlackWindow41, #lightbox-panel41,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel42").click(function(){  
$("#BlackWindow42, #lightbox-panel42").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel42").click(function(){  
$("#BlackWindow42, #lightbox-panel42").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow42").click(function(){  
$("#BlackWindow42, #lightbox-panel42,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})


$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel43").click(function(){  
$("#BlackWindow43, #lightbox-panel43").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel43").click(function(){  
$("#BlackWindow43, #lightbox-panel43").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow43").click(function(){  
$("#BlackWindow43, #lightbox-panel43,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel44").click(function(){  
$("#BlackWindow44, #lightbox-panel44").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel44").click(function(){  
$("#BlackWindow44, #lightbox-panel44").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow44").click(function(){  
$("#BlackWindow44, #lightbox-panel44,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel45").click(function(){  
$("#BlackWindow45, #lightbox-panel45").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel45").click(function(){  
$("#BlackWindow45, #lightbox-panel45").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow45").click(function(){  
$("#BlackWindow45, #lightbox-panel45,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel46").click(function(){  
$("#BlackWindow46, #lightbox-panel46").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel46").click(function(){  
$("#BlackWindow46, #lightbox-panel46").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow46").click(function(){  
$("#BlackWindow46, #lightbox-panel46,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel47").click(function(){  
$("#BlackWindow47, #lightbox-panel47").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel47").click(function(){  
$("#BlackWindow47, #lightbox-panel47").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow47").click(function(){  
$("#BlackWindow47, #lightbox-panel47,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel48").click(function(){  
$("#BlackWindow48, #lightbox-panel48").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel48").click(function(){  
$("#BlackWindow48, #lightbox-panel48").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow48").click(function(){  
$("#BlackWindow48, #lightbox-panel48,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel49").click(function(){  
$("#BlackWindow49, #lightbox-panel49").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel49").click(function(){  
$("#BlackWindow49, #lightbox-panel49").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow49").click(function(){  
$("#BlackWindow49, #lightbox-panel49,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel50").click(function(){  
$("#BlackWindow50, #lightbox-panel50").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel50").click(function(){  
$("#BlackWindow50, #lightbox-panel50").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow50").click(function(){  
$("#BlackWindow50, #lightbox-panel50,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel51").click(function(){  
$("#BlackWindow51, #lightbox-panel51").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel51").click(function(){  
$("#BlackWindow51, #lightbox-panel51").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow51").click(function(){  
$("#BlackWindow51, #lightbox-panel51,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel52").click(function(){  
$("#BlackWindow52, #lightbox-panel52").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel52").click(function(){  
$("#BlackWindow52, #lightbox-panel52").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow52").click(function(){  
$("#BlackWindow52, #lightbox-panel52,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel53").click(function(){  
$("#BlackWindow53, #lightbox-panel53").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel53").click(function(){  
$("#BlackWindow53, #lightbox-panel53").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow53").click(function(){  
$("#BlackWindow53, #lightbox-panel53,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel54").click(function(){  
$("#BlackWindow54, #lightbox-panel54").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel54").click(function(){  
$("#BlackWindow54, #lightbox-panel54").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow54").click(function(){  
$("#BlackWindow54, #lightbox-panel54,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel55").click(function(){  
$("#BlackWindow55, #lightbox-panel55").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel55").click(function(){  
$("#BlackWindow55, #lightbox-panel55").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow55").click(function(){  
$("#BlackWindow55, #lightbox-panel55,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel56").click(function(){  
$("#BlackWindow56, #lightbox-panel56").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel56").click(function(){  
$("#BlackWindow56, #lightbox-panel56").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow56").click(function(){  
$("#BlackWindow56, #lightbox-panel56,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel57").click(function(){  
$("#BlackWindow57, #lightbox-panel57").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel57").click(function(){  
$("#BlackWindow57, #lightbox-panel57").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow57").click(function(){  
$("#BlackWindow57, #lightbox-panel57,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel58").click(function(){  
$("#BlackWindow58, #lightbox-panel58").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel58").click(function(){  
$("#BlackWindow58, #lightbox-panel58").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow58").click(function(){  
$("#BlackWindow58, #lightbox-panel58,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel59").click(function(){  
$("#BlackWindow59, #lightbox-panel59").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel59").click(function(){  
$("#BlackWindow59, #lightbox-panel59").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow59").click(function(){  
$("#BlackWindow59, #lightbox-panel59,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel60").click(function(){  
$("#BlackWindow60, #lightbox-panel60").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel60").click(function(){  
$("#BlackWindow60, #lightbox-panel60").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow60").click(function(){  
$("#BlackWindow60, #lightbox-panel60,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel61").click(function(){  
$("#BlackWindow61, #lightbox-panel61").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel61").click(function(){  
$("#BlackWindow61, #lightbox-panel61").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow61").click(function(){  
$("#BlackWindow61, #lightbox-panel61,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel62").click(function(){  
$("#BlackWindow62, #lightbox-panel62").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel62").click(function(){  
$("#BlackWindow62, #lightbox-panel62").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow62").click(function(){  
$("#BlackWindow62, #lightbox-panel62,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel63").click(function(){  
$("#BlackWindow63, #lightbox-panel63").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel63").click(function(){  
$("#BlackWindow63, #lightbox-panel63").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow63").click(function(){  
$("#BlackWindow63, #lightbox-panel63,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel64").click(function(){  
$("#BlackWindow64, #lightbox-panel64").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel64").click(function(){  
$("#BlackWindow64, #lightbox-panel64").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow64").click(function(){  
$("#BlackWindow64, #lightbox-panel64,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel65").click(function(){  
$("#BlackWindow65, #lightbox-panel65").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel65").click(function(){  
$("#BlackWindow65, #lightbox-panel65").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow65").click(function(){  
$("#BlackWindow65, #lightbox-panel65,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel66").click(function(){  
$("#BlackWindow66, #lightbox-panel66").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel66").click(function(){  
$("#BlackWindow66, #lightbox-panel66").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow66").click(function(){  
$("#BlackWindow66, #lightbox-panel66,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel67").click(function(){  
$("#BlackWindow67, #lightbox-panel67").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel67").click(function(){  
$("#BlackWindow67, #lightbox-panel67").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow67").click(function(){  
$("#BlackWindow67, #lightbox-panel67,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  


//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel68").click(function(){  
$("#BlackWindow68, #lightbox-panel68").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel68").click(function(){  
$("#BlackWindow68, #lightbox-panel68").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow68").click(function(){  
$("#BlackWindow68, #lightbox-panel68,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel69").click(function(){  
$("#BlackWindow69, #lightbox-panel69").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel69").click(function(){  
$("#BlackWindow69, #lightbox-panel69").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow69").click(function(){  
$("#BlackWindow69, #lightbox-panel69,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel70").click(function(){  
$("#BlackWindow70, #lightbox-panel70").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel70").click(function(){  
$("#BlackWindow70, #lightbox-panel70").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow70").click(function(){  
$("#BlackWindow70, #lightbox-panel70,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel71").click(function(){  
$("#BlackWindow71, #lightbox-panel71").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel71").click(function(){  
$("#BlackWindow71, #lightbox-panel71").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow71").click(function(){  
$("#BlackWindow71, #lightbox-panel71,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel72").click(function(){  
$("#BlackWindow72, #lightbox-panel72").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel72").click(function(){  
$("#BlackWindow72, #lightbox-panel72").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow72").click(function(){  
$("#BlackWindow72, #lightbox-panel72,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel73").click(function(){  
$("#BlackWindow73, #lightbox-panel73").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel73").click(function(){  
$("#BlackWindow73, #lightbox-panel73").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow73").click(function(){  
$("#BlackWindow73, #lightbox-panel73,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel74").click(function(){  
$("#BlackWindow74, #lightbox-panel74").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel74").click(function(){  
$("#BlackWindow74, #lightbox-panel74").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow74").click(function(){  
$("#BlackWindow74, #lightbox-panel74,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel75").click(function(){  
$("#BlackWindow75, #lightbox-panel75").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel75").click(function(){  
$("#BlackWindow75, #lightbox-panel75").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow75").click(function(){  
$("#BlackWindow75, #lightbox-panel75,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel76").click(function(){  
$("#BlackWindow76, #lightbox-panel76").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel76").click(function(){  
$("#BlackWindow76, #lightbox-panel76").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow76").click(function(){  
$("#BlackWindow76, #lightbox-panel76,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel77").click(function(){  
$("#BlackWindow77, #lightbox-panel77").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel77").click(function(){  
$("#BlackWindow77, #lightbox-panel77").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow77").click(function(){  
$("#BlackWindow77, #lightbox-panel77,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel78").click(function(){  
$("#BlackWindow78, #lightbox-panel78").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel78").click(function(){  
$("#BlackWindow78, #lightbox-panel78").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow78").click(function(){  
$("#BlackWindow78, #lightbox-panel78,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel79").click(function(){  
$("#BlackWindow79, #lightbox-panel79").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel79").click(function(){  
$("#BlackWindow79, #lightbox-panel79").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow79").click(function(){  
$("#BlackWindow79, #lightbox-panel79,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel80").click(function(){  
$("#BlackWindow80, #lightbox-panel80").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel80").click(function(){  
$("#BlackWindow80, #lightbox-panel80").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow80").click(function(){  
$("#BlackWindow80, #lightbox-panel80,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})

$(document).ready(function(){  
//show-panelボタンをクリックしたらLightBoxを表示する  
$("a#show-panel81").click(function(){  
$("#BlackWindow81, #lightbox-panel81").fadeIn(300);/*表示速度は数値を調整*/  
})  
//CloseボタンをクリックしたらLightBoxを閉じる  
$("a#close-panel81").click(function(){  
$("#BlackWindow81, #lightbox-panel81").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
//背景の黒地をクリックしたらLightBoxを閉じる  
$("#BlackWindow81").click(function(){  
$("#BlackWindow81, #lightbox-panel81,").fadeOut(300);/*フォードアウトの速度は数値を調整*/  
})  
})